export default __webpack_public_path__ + "static/media/baixarvenda1.d2c25291.png";